export default () => {
    $("#navigation").insertBefore(".navigation-buttons");
    $(".top-navigation-tools").prependTo(".navigation-buttons");
    $('.search').remove()
    $('.responsive-tools').insertBefore('.navigation-buttons')

    $('.menu-level-1 li').each(function() {
        $(this).removeClass('ext splitted')
    })

    $('.top-nav-button-login').removeClass('toggle-window')
    $('.cart-count').removeClass('toggle-window')

    $('.dropdown').clone().appendTo('#navigation')
}